import { render, staticRenderFns } from "./NewsletterPublic.vue?vue&type=template&id=68bf97b5&scoped=true&"
import script from "./NewsletterPublic.vue?vue&type=script&lang=js&"
export * from "./NewsletterPublic.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterPublic.vue?vue&type=style&index=0&id=68bf97b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf97b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bf97b5')) {
      api.createRecord('68bf97b5', component.options)
    } else {
      api.reload('68bf97b5', component.options)
    }
    module.hot.accept("./NewsletterPublic.vue?vue&type=template&id=68bf97b5&scoped=true&", function () {
      api.rerender('68bf97b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/NewsletterPublic.vue"
export default component.exports